import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";

import {
  fetchActiveRewards,
  resetData,
} from "../../redux/slice/offers/activeRewards";

import "./OffersHistory.scss";
import Spinner from "../../component/spinner/Spinner";
import NoDataComp from "../../component/NoDataComp";
import {
  formatCouponExpiry,
  formatRewardCatalogueAmount,
  getCouponExpiry,
} from "../../utils/common";
// import gold_rupe_icon_md from "../../assets/images/gold_rupe_md.svg";

const ActiveOffers = ({ mall }) => {
  const dispatch = useDispatch();
  const { activeRewardsData, loading } = useSelector(
    (state) => state.activeReward
  );

  const [rewardsById, setRewardsById] = useState({});
  const [voucherList, setVoucherList] = useState([]);
  const [filteredRewards, setFilteredRewards] = useState([]);

  // console.log(activeRewardsData, "activeRewardsData");

  const logicForMultipleVouchers = (data) => {
    const hash = {};
    const listOfVouchers = [];

    for (let i = 0; i < data.length; i++) {
      hash[data[i].rewardDetails?.rewardId] = data[i].rewardDetails;
      listOfVouchers.push(data[i]?.vouchers);
    }

    // Logic to filter out by mall
    const flat = listOfVouchers?.flat(1);
    let output = [];

    for (let i = 0; i < flat?.length; i++) {
      if (hash[flat[i]?.rewardId]) {
        output.push({ ...flat[i], ...hash[flat[i]?.rewardId] });
      }
    }
    // console.log(hash, "hash");
    // console.log(output, "output");
    // console.log(listOfVouchers.flat(1), "listOfVouchers");
    if(listOfVouchers){
      const newVouchers = listOfVouchers?.flat(1)?.sort((a, b) => new Date(b.issued) - new Date(a.issued));
      const now = new Date();
      const nonExpiredVouchers = newVouchers.filter((item) => {
        const expiryDate = getCouponExpiry(item.issued);
        if (!expiryDate) return true;
        return expiryDate.endOf("day").toDate() >= now;
      });
      setVoucherList(nonExpiredVouchers);
    }else{
      setVoucherList([]);
    }
    setRewardsById(hash);
  };

  useEffect(() => {
    dispatch(fetchActiveRewards({ status: "active" }));
    return () => {
      dispatch(resetData());
    };
  }, [dispatch]);

  useEffect(() => {
    if (activeRewardsData?.length > 0) {
      logicForMultipleVouchers(activeRewardsData);
    }
  }, [activeRewardsData]);

  useEffect(() => {
    if (mall === "All" || mall === "") {
      setFilteredRewards(activeRewardsData);
    } else {
      const result = activeRewardsData?.filter(
        (el) => el.categoryList?.[0]?.name === mall
      );
      // console.log(result, "result");
      setFilteredRewards(result);
    }
  }, [activeRewardsData, mall]);

  // console.log(voucherList, "voucher list");
  return (
    <div
      className="tabTable"
      style={{ maxHeight: "100vh", overflowY: "scroll" }}
    >
      <div className="border_bottom_section">
        {voucherList?.length > 0 ?
        voucherList?.map((voucher,index) => (
          <div className="mobile-div" key={index}>
            <p className="mobile_content">
              {moment(voucher?.issued).format(
                "DD MMM YY"
              )}
            </p>
            <div className="d-flex justify-content-between transction_list">
              <div className="hotel_booking_details d-flex align-items-center">
                <img
                  className="hotel_Icon_div"
                  src={rewardsById[voucher?.rewardId]?.imageUrl}
                  alt="puma logo"
                />
                <div className="details-container">
                  <p className="desktop_content">
                    {moment(voucher?.issued).format(
                      "DD MMM YY"
                    )}
                  </p>
                  <h1>{rewardsById[voucher?.rewardId]?.name}</h1>
                  {formatCouponExpiry(voucher?.issued) && (
                    <p className="coupon-expiry">
                      Expires on {formatCouponExpiry(voucher?.issued)}
                    </p>
                  )}
                  <div className="active-status">
                    <div
                      style={{
                        backgroundColor: `${"#1A9F0B"}`,
                      }}
                    ></div>
                    <p
                      style={{
                        color: `${"#1A9F0B"}`,
                      }}
                    >
                      Active
                    </p>
                  </div>
                </div>
              </div>
              <div className="points_gold" style={{flexDirection: "column", gap: "5px"}}>
                <p>{voucher?.pointsRedeemed == 0? "Special Benefits": `₹ ${formatRewardCatalogueAmount(voucher?.pointsRedeemed)}`}</p>
                <p className="high_light_text">
                  {voucher?.code}
                  {/* <img src={gold_rupe_icon_md} alt="gold coin icon" /> */}
                </p>
              </div>
            </div>
          </div>
        )): (loading ? null :<NoDataComp />)}
      </div>

      {loading ? (
        <div
          style={{
            height: "200px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Spinner color="black" size="28px" />
        </div>
      ) : null}
    </div>
  );
};

export default ActiveOffers;
